import React, { FC, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Header, Body } from "../styled";
import { Typography } from "@mui/material";
import { format, formatISO } from "date-fns";

const FirstEducation: FC = () => {

  return (
    <Box mt={1}>
      <Header>
        <Box display='flex'>
          <TextField
            label="Представитель"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 1, width: "500px" }}
          />
          <TextField
            label="Текущее состояние"
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "500px" }}
          />
        </Box>
        <Box> 
          <TextField
              label="Рост"
              variant="outlined"
              size="small"
              sx={{ mr: 1, mb: 1, width: "500px" }}
            />
          <TextField
              label="Масса"
              variant="outlined"
              size="small"
              sx={{ mr: 1, mb: 1, width: "500px" }}
            />
        </Box>
        <Box> 
          <TextField
              label="Окружность головы"
              variant="outlined"
              size="small"
              sx={{ mr: 1, mb: 1, width: "500px" }}
            />
          <TextField
              label="Окружность груди"
              variant="outlined"
              size="small"
              sx={{ mr: 1, mb: 1, width: "500px" }}
            />
        </Box>

        <Box display='flex'>
          <TextField
            label="Оценка"
            variant="outlined"
            size="small"
            sx={{ mr: 38, mb: 1, width: "204px"}}
          />
          <TextField
            label="Дата регистрации"
            value={format(1683886255004, "dd.MM.yyyy")}
            variant="outlined"
            size="small"
            sx={{ width: "200px", mr: 1 }}
          />
        </Box>
        <Box display='flex'>
          <TextField
            label="МО госпитализации"
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "500px" }}
          />
          <TextField
            label="МО рождения"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 1, width: "500px" }}
          />
        </Box>
        <Box>
          <TextField
            label="Особенности ребенка при рождении"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 1, width: "500px" }}
          />
          <TextField
            label="Проба для неонат. скрининга"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 5, width: "500px" }}
          />
        </Box>

      </Header>
      <Body>
        <Box display='flex'>
          <TextField
            label="Адрес регистрации"
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "500px" }}
          />
          <TextField
            label="Реквизиты адреса регистрации"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 1, width: "500px" }}
          />
        </Box>
        <Box display='flex'>
          <TextField
            label="Индетификатор адреса проживания"
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "500px" }}
          />
          <TextField
            label="Реквизиты адреса проживания"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 1, width: "500px" }}
          />
        </Box>
        <TextField
          label="Телефон"
          variant="outlined"
          size="small"
          sx={{ width: "500px", mb: 5 }}
        />
        <TextField
          label="Риск"
          variant="outlined"
          size="small"
          sx={{ width: "500px", mb: 2}}
        />
        <TextField
          label="Специфика новорожденных"
          variant="outlined"
          size="small"
          sx={{ width: "500px", mb: 2}}
        />
        <TextField
          label="Регистр беременных"
          variant="outlined"
          size="small"
          sx={{ width: "500px", mb: 2}}
        />
        <TextField
          label="Вич у матери"
          variant="outlined"
          size="small"
          sx={{ width: "500px", mb: 2}}
        />
        <TextField
          label="Covid у матери"
          variant="outlined"
          size="small"
          sx={{ width: "500px", mb: 2}}
        />
        <TextField
          label="Отказ от ребенка"
          variant="outlined"
          size="small"
          sx={{ width: "500px", mb: 2}}
        />
      </Body>
    </Box>
  );
};

export default FirstEducation;